import { Box } from '@mui/material';
import {
  PlansDetailSection,
  PlansHeaderSection,
  StyledActivityCardBackground
} from 'modules';
import React from 'react';
import {
  Outlet,
  useLocation
} from 'react-router-dom';



export type PlansActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const PlansActivity = (props: PlansActivityProps) => {
  const location = useLocation();

  if (!location.pathname.endsWith('plans')) {
    return <Outlet />;
  }
  return (
    <Box >
      {/* DETAIL SECTION */}
      <StyledActivityCardBackground.FC>
        <PlansHeaderSection.FC />
        <PlansDetailSection.FC />
      </StyledActivityCardBackground.FC>
      {/* PLAN HEADER SECTION */}

    </Box>
  );
};
